import { Skeleton } from '@/components/ui/skeleton';
import { Separator } from '@/components/ui/separator';
import CommitThreadSkeleton from '../commit/CommitThreadSkeleton';

export default function ProfileSkeleton() {
  return (
    <>
      {/* Profile Header */}
      <div className="pt-8 pb-4">
        <div className="flex flex-col sm:flex-row gap-6">
          {/* Avatar */}
          <div className="flex-shrink-0">
            <Skeleton className="h-24 w-24 sm:h-28 sm:w-28 rounded-full" />
          </div>

          {/* Info */}
          <div className="flex-1 min-w-0">
            <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
              <div className="min-w-0">
                <Skeleton className="h-7 w-48 mb-2" />
                <Skeleton className="h-4 w-32" />
              </div>
              <Skeleton className="h-9 w-24 rounded-md" />
            </div>

            {/* Bio */}
            <div className="mt-3 space-y-2">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-2/3" />
            </div>

            {/* Meta info (location only) */}
            <div className="flex items-center gap-4 mt-4">
              <Skeleton className="h-4 w-24" />
            </div>

            {/* Social links */}
            <div className="flex items-center gap-3 mt-4">
              <Skeleton className="h-8 w-8 rounded-lg" />
              <Skeleton className="h-8 w-8 rounded-lg" />
              <Skeleton className="h-8 w-8 rounded-lg" />
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="flex items-center justify-between mt-4">
          <div className="flex items-center gap-4">
            <Skeleton className="h-4 w-20" />
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-4 w-24" />
          </div>
          <Skeleton className="h-4 w-28" />
        </div>
      </div>

      <Separator />

      {/* Branch Highlights */}
      <div className="py-4">
        <div className="flex flex-wrap gap-2">
          <Skeleton className="h-8 w-20 rounded-full" />
          <Skeleton className="h-8 w-24 rounded-full" />
          <Skeleton className="h-8 w-28 rounded-full" />
        </div>
      </div>

      {/* Commits Section */}
      <div className="pt-2 pb-6">
        <CommitThreadSkeleton count={3} />
      </div>
    </>
  );
}
